import { render, staticRenderFns } from "./MeetingDetailAccordion.vue?vue&type=template&id=00dd27f4&scoped=true&"
import script from "./MeetingDetailAccordion.vue?vue&type=script&lang=js&"
export * from "./MeetingDetailAccordion.vue?vue&type=script&lang=js&"
import style0 from "./MeetingDetailAccordion.vue?vue&type=style&index=0&id=00dd27f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd27f4",
  null
  
)

export default component.exports